import { Check, X } from "lucide-react";
import { Reveal, SectionHeading, SectionCta } from "./Reveal";

const COLUMNS = ["In-house front desk hire", "Offshore VA", "Answering service", "North & Noble"];

const ROWS = [
  { label: "Answers in under 5 min", values: ["x", "x", "x", "check"] },
  { label: "Works leads until booked", values: ["x", "x", "x", "check"] },
  { label: "Collects deposits", values: ["x", "x", "x", "check"] },
  { label: "Covers sick days and vacations", values: ["x", "x", "check", "check"] },
  { label: "Weekly KPI scorecard", values: ["x", "x", "x", "check"] },
  { label: "One accountable owner", values: ["x", "x", "x", "check"] },
  { label: "Medical-aesthetic trained", values: ["x", "x", "x", "check"] },
  { label: "Monthly cost range", values: ["[$X,XXX/mo]", "[$XXX/mo]", "[$XXX/mo]", "[FLAT MONTHLY RATE]"] },
];

const Cell = ({ value }) => {
  if (value === "check")
    return (
      <span className="inline-flex items-center gap-2 text-emerald-600">
        <Check size={16} strokeWidth={2.5} />
        <span className="text-sm sr-only lg:not-sr-only">Yes</span>
      </span>
    );
  if (value === "x")
    return (
      <span className="inline-flex items-center gap-2 text-red-400">
        <X size={16} strokeWidth={2.5} />
        <span className="text-sm sr-only lg:not-sr-only">No</span>
      </span>
    );
  return <span className="font-mono text-sm text-zinc-500">{value}</span>;
};

export const Comparison = () => (
  <section data-testid="comparison-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        eyebrow="Side by side"
        title={
          <>
            Your four options, <span className="italic text-champagne">honestly compared.</span>
          </>
        }
        copy="Every alternative leaves you managing someone. The Engine removes the management layer entirely."
      />
      <Reveal className="mt-16 overflow-x-auto border border-black/10 bg-coal shadow-sm">
        <table className="w-full min-w-[820px] text-left" data-testid="comparison-table">
          <thead>
            <tr className="border-b border-black/10 bg-carbon">
              <th className="px-6 py-5 text-xs font-mono tracking-widest uppercase text-zinc-500 font-normal" />
              {COLUMNS.map((c, i) => (
                <th
                  key={c}
                  className={`px-6 py-5 text-sm font-normal tracking-wide ${
                    i === COLUMNS.length - 1 ? "text-champagne bg-champagne/10 border-x border-champagne/30" : "text-zinc-600"
                  }`}
                >
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row, ri) => (
              <tr
                key={row.label}
                data-testid={`comparison-row-${ri}`}
                className="border-b border-black/5 hover:bg-champagne/[0.03] transition-colors duration-300"
              >
                <td className="px-6 py-4 text-sm text-pearl">{row.label}</td>
                {row.values.map((v, ci) => (
                  <td
                    key={ci}
                    className={`px-6 py-4 ${ci === row.values.length - 1 ? "bg-champagne/10 border-x border-champagne/30" : ""}`}
                  >
                    <Cell value={v} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Reveal>
      <SectionCta id="comparison" label="Stop managing. Start booking." />
    </div>
  </section>
);
